import { z } from 'zod/v4';

/**
 * Body of the bulk-unarchive endpoint.
 *
 * The legacy route took a bare JSON array (`["id1","id2"]`); this wraps it in a
 * named field so the payload is self-describing in the generated OpenAPI
 * reference, produces useful validation paths
 * (`body/questionnaireIds/0` rather than `body/0`), and can gain further fields
 * without a breaking change. Matches the sibling
 * `questionnaire-archive.ts` / `questionnaire-delete.ts` house style.
 *
 * Constraints map 1:1 to the legacy `bulkUnArchive` JSON Schema:
 * `minItems: 1` → `.min(1)`, `items.minLength: 1` → `z.string().min(1)`.
 * Deliberately **uncapped**, as the legacy route was — a `.max()` would newly
 * reject payloads that work today.
 *
 * Duplicates are deliberately NOT rejected here: the service compares the row
 * count it finds against `questionnaireIds.length`, so `["a","a"]` resolves to a
 * single row and fails with `questionnaire_not_found`, exactly as the legacy
 * route did.
 */
export const BulkUnarchiveQuestionnairesBodySchema = z.object({
  questionnaireIds: z.array(z.string().min(1)).min(1),
});

export type BulkUnarchiveQuestionnairesBody = z.infer<
  typeof BulkUnarchiveQuestionnairesBodySchema
>;
